import { BaseModel } from './hateoas/base-model';
import { Link } from './hateoas/link';
import { MessageFieldModel } from './message-field-model';

export class CommandModel extends BaseModel {
  uuid: string;
  protocolUuid: string;
  name: string;
  description: string;
  direction: string;
  processingType: string;
  header: string;
  validateChecksum: boolean;
  checksumPosition: string;
  checksumCalcType: string;
  dataFormat: string;
  sendResponse: boolean;
  fixedSize: boolean;
  status: string;
  terminalIdentification: boolean;
  commandDescriptionTemplate: string;
  commandAction: string;
  /** Quando true (`requires_reauth` na API), o envio genérico exige reautenticação. */
  requiresReauth?: boolean;
  /**
   * Delimitador para campos com múltiplos valores (`allows_multiple_values`).
   * Vem do prepare-command-form (`char_delimiter`).
   */
  charDelimiter?: string;
  messageFields: MessageFieldModel[];
} 